import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { reorder } from '../../../functions'

import ListItem from './list-item'

class List extends Component {
  constructor(props) {
    super(props)

    this.state = {
      items: []
    }
  }

  componentWillMount() {
    const { items } = this.props

    this.setState({items})
  }

  componentWillUpdate(nextProps, nextState) {
    const { items } = nextProps

    if (items !== this.props.items) this.setState({items})
  }

  reorderList = (result) => {
    if (!result.destination) return null

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    )

    this.setState({items}, () => this.props.moveRiderItem({id: result.draggableId, position: result.destination.index+1}))
  }

  render() {
    const { view, requirements } = this.props
    const { items } = this.state

    return (
      <div className="list">
        <DragDropContext onDragEnd={this.reorderList}>
          <Droppable droppableId="list" isDropDisabled={!view.editable} type="requirement">
            {(provided, snapshot) => (
              <div className="list--droppable"
                ref={provided.innerRef} >
                {
                  items.length > 0
                  ? items.map((item, index) => {
                      return item.class === 'requirement'
                      ? <ListItem key={item.id || index}
                          view={view}
                          item={item}
                          required={item.required}
                          removeRiderItem={this.props.removeRiderItem}
                          createRiderItem={(item) => this.props.createRiderItem({...item})}
                          editRiderItem={this.props.editRiderItem}
                          deleteRiderItem={this.props.deleteRiderItem} />
                      : null
                    })
                  : <p>Start by adding your <a onClick={() => {
                      this.props.addRiderItem({
                        ...requirements,
                        position: items.length+1,
                        indexes: [
                          items.length
                        ]
                      })
                    }}>first requirement</a>.</p>
                }

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        {
          view.editable
          ? <button className="list--add-button button--link" onClick={() => {
              this.props.addRiderItem({
                ...requirements,
                position: items.length+1,
                indexes: [
                  items.length
                ]
              })
            }}>
              Insert {requirements.title}
            </button>
          : null
        }
      </div>
    )
  }
}

List.propTypes = {
  view: PropTypes.object,
  requirements: PropTypes.object,
  items: PropTypes.array,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func
}

List.defaultProps = {
  view: {},
  requirements: {},
  items: [],
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {}
}

export default List



// WEBPACK FOOTER //
// ./src/components/rider/rider-requirements/requirement-list/list.js